<template>
  <div className="flex flex-col min-h-screen overflow-hidden supports-[overflow:clip]:overflow-clip">

    <!-- Page content -->
      <main class="grow flex flex-col items-center justify-center pt-20">
      <section class="m-4 p-4 shadow-md rounded-lg max-w-4xl">
          <h2 class="text-3xl font-semibold mb-10 text-white">Cookie Policy</h2>
          <div class="text-white">
          <strong>Last Updated:</strong> 2024-03-01<br><br>
          Portex AI uses cookies to improve your experience on our website and platform, both located at <a href="https://portexai.com" class="text-blue-300">portexai.com</a>. By using our services, you consent to the use of cookies in accordance with this Cookie Policy.<br><br>
          <strong>What are Cookies?</strong><br>
          Cookies are small text files that are stored on your device when you visit a website. They are used to remember your preferences, login information, and provide personalized content.<br><br>
          <strong>How We Use Cookies</strong><br>
          We use cookies for the following purposes:<br>
          <div class="pl-5">
              <ul class="list-disc">
              <li><strong>Essential Cookies:</strong> These are necessary for the website to function properly and cannot be switched off in our systems.</li>
              <li><strong>Performance Cookies:</strong> These cookies help us understand how visitors interact with our website, providing information about areas visited, time spent, and any issues encountered.</li>
              <li><strong>Functional Cookies:</strong> These cookies enable enhanced functionality and personalization, such as remembering your preferences.</li>
              </ul><br>
          </div>
          <strong>Managing Cookies</strong><br>
          You can manage cookies through your browser settings. However, please note that disabling cookies may affect the functionality of our website and your user experience.<br><br>
          <strong>Changes to This Policy</strong><br>
          We may update this Cookie Policy from time to time. The latest version will be available on our website, and we will indicate the date of the last update at the top of this policy.<br><br>
          <strong>Contact Us</strong><br>
          If you have any questions about our use of cookies, please contact us at <a href="mailto:hello@portexai.com" class="text-blue-300">hello@portexai.com</a>.<br><br>
          </div>
      </section>
      </main>


    <!-- Site footer -->
    <Footer />    

  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'Cookies',
  components: {
    Footer,
  },
}
</script>
